const Keys = require("../enums/NotesKey");

/**
 * Generate notes list
 * @param {Object} infoJSON info.json file contents from .is2 file
 * @returns {Array} List of notes
 */
const generateNotesList = (infoJSON) => {
  const notesList = [];

  const notes = infoJSON?.TEXTNOTES;

  if (notes) {
    notes.forEach((note) => {
      const requiredKeys = ["date", "author", "text", "timezone"];
      const hasRequiredKeys = requiredKeys.every((key) =>
        note.hasOwnProperty(key)
      );

      if (!hasRequiredKeys) {
        throw new Error("Invalid note object");
      }

      notesList.push({
        [Keys.DATE]: note.date,
        [Keys.USER]: note.author,
        [Keys.TEXT]: note.text,
        [Keys.TIMEZONE]: note.timezone,
      });
    });
  }

  return notesList;
};

module.exports = {
  generateNotesList,
};
